import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import RepresentanteService from "service/fiscal/RepresentanteService";
import { filterApplyTemplate, TextMatchModeOptions } from "utils/filterUtils";

const representanteService = new RepresentanteService();

export default function RepresentanteListagem() {
    const defaultFilters: DataTableFilterMeta = {
        nome: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND },
        numeroDocumento: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND }
    };

    return (
        <BaseListagem ordenacao="codigoInterno,ASC" service={representanteService} urlService="/representante"
            tituloPagina="Representantes" defaultFilters={defaultFilters} showClearFilterButton nome="representante">
            <Column field="codigoInterno" header="Código" />
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="numeroDocumento" header="Documento" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="tipoPessoa" header="Tipo de pessoa" body={(rowData) => representanteService.getTipoPessoa(rowData.tipoPessoa)} />
            <Column field="ativo" header="Ativo" body={(rowData) => rowData.ativo ? "Sim" : "Não"} />
        </BaseListagem>
    );
}
